import http from "../../http-common";
import axios from "axios";
class ProductService {
    getAll() {
        return axios.get("/api/products");
    }
    get(id) {
        return axios.get(`/api/products/${id}`);
    }
    searchProductByName(data) {
        return axios.post("/api/products/searchProductByName", data);
    }
    fetchProductByCategoryId(id) {
        return axios.get(`/api/products/fetchProductByCategoryId/${id}`);
    }
    fetchProducts(filters = {}) {
        const params = Object.fromEntries(
            Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined && value !== 0)
        );
        return axios.get("/api/products/fetchProducts", { params });
    }
    fetchById(id) {
        return axios.get(`/api/products/fetchById/${id}`);
    }
    fetchProductByCategoryIdV2(id) {
        return axios.get(`/api/products/fetchProductByCategoryIdV2/${id}`);
    }
    fetchProductEnabled(id) {
        return axios.get(`/api/products/fetchProductEnabled/${id}`);
    }
    fetchProductListV2(id) {
        return axios.get(`/api/products/fetchProductListV2/${id}`);
    }
    fetchProductToNotify(id) {
        return axios.get(`/api/products/fetchProductToNotify/${id}`);
    }
    fetchProductListNote(id) {
        return axios.get(`/api/products/fetchProductListNote/${id}`);
    }
    fetchProductListExpiration(filters = {}) {
        const params = Object.fromEntries(
            Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined && value !== 0)
        );
        return axios.get("/api/products/fetchProductListExpiration", { params });
    }
    fetchOrderSupplierExpirationList(id) {
        return axios.get(`/api/products/fetchOrderSupplierExpirationList/${id}`);
    }
    fetchProductValue(id) {
        return axios.get(`/api/products/fetchProductValue/${id}`);
    }
    fetchByStockWarning(id) {
        return axios.get(`/api/products/fetchByStockWarning/${id}`);
    }
    fetchStockWarnings(filters = {}) {
        const params = Object.fromEntries(
            Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined && value !== 0)
        );
        return axios.get("/api/products/fetchStockWarnings", { params });
    }
    fetchStocks(filters = {}) {
        const params = Object.fromEntries(
            Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined && value !== 0)
        );
        return axios.get("/api/products/fetchStocks", { params });
    }
    fetchNoStockWarning(id) {
        return axios.get(`/api/products/fetchNoStockWarning/${id}`);
    }
    fetchOutOfStock(filters = {}) {
        const params = Object.fromEntries(
            Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined && value !== 0)
        );
        return axios.get("/api/products/fetchOutOfStock", { params });
    }
    fetchStockWarningPerSupplier(id) {
        return axios.get(`/api/products/fetchStockWarningPerSupplier/${id}`);
    }
    fetchStockPerSupplier(id) {
        return axios.get(`/api/products/fetchStockPerSupplier/${id}`);
    }
    fetchProductListDisabled(id) {
        return axios.get(`/api/products/fetchProductListDisabled/${id}`);
    }
    fetchProductMonthlySales(month, filters = {}) {
        return axios.get("/api/products/fetchProductMonthlySales", {
            params: { month, ...filters },
        });
    }
    fetchModifiedStockDaily(id, typeList = []) {
        return axios.get(`/api/products/fetchModifiedStockDaily/${id}`, {
            params: typeList.length > 0 ? { typeList } : {}
        });
    }
    fetchPendingProduct(data) {
        return axios.post("/api/products/fetchPendingProduct", data);
    }
    fetchModifiedReportList(data) {
        return axios.post("/api/products/fetchModifiedReportList", data);
    }
    getUnsoldProducts(data) {
        return axios.post("/api/products/getUnsoldProducts", data);
    }
    create(data) {
        return axios.post("/api/products", data);
    }
    testController(data) {
        return axios.post("/api/products/testController", data);
    }
    update(id, data) {
        return axios.put(`/api/products/${id}`, data);
    }
    updateV2(id, data) {
        return axios.put(`/api/products/updateV2/${id}`, data);
    }
    delete(brand) {
        return axios.delete(`/api/products/${brand}`);
    }
    deleteAll() {
        return axios.delete(`/api/products`);
    }
    findByTitle(brandName) {
        return axios.get(`/api/products/getId/${brandName}`);
    }
    sanctum() {
        return axios.get("/sanctum/csrf-cookie");
    }
}
export default new ProductService();
